<script setup>
import { ref, watch } from 'vue'
import { Switch } from '@headlessui/vue'

const props = defineProps({
	modelValue: {
		type: Boolean,
		required: true,
	},
	label: {
		type: String,
	}
})

const enabled = ref(props.modelValue)

const emit = defineEmits(['update:modelValue'])

watch(enabled, (value) => {
	emit('update:modelValue', value)
})

</script>


<template>
	<Switch v-model="enabled"  :class="[enabled ? 'bg-Blue' : 'bg-gray-200', 'relative inline-flex h-4 w-8 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none']">
		<span class="sr-only">Use setting</span>
		<span aria-hidden="true" :class="[enabled ? 'translate-x-4' : 'translate-x-0', 'pointer-events-none inline-block h-3 w-3 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out']" />
	</Switch>	
</template>
